import { observer } from 'mobx-react-lite';
import { EditLookupToolbarProps } from './EditLookupToolbar.types';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';
import { BaseToolbar } from '../base-toolbar/BaseToolbar';
import { useEditLookupToolbarLogic } from './EditLookupToolbar.logic';
import { forwardRef } from 'react';
import { BaseToolbarMobile } from '../base-toolbar/BaseToolbarMobile';

export const EditLookupToolbar = observer(
  forwardRef((props: EditLookupToolbarProps, ref) => {
    const { isDesktop } = useResponsiveScreen();
    const { isVisible = true } = props;

    const toolbarProps = useEditLookupToolbarLogic(props);

    return isDesktop ? (
      <BaseToolbar ref={ref} tilesExpandAnimationEnabled={false} {...toolbarProps} isVisible={isVisible} />
    ) : (
      <BaseToolbarMobile {...toolbarProps} isVisible={isVisible} />
    );
  }),
);

EditLookupToolbar.displayName = 'EditLookupToolbar';
